module.exports = __webpack_public_path__ + "assets/addhero.16.svg";